import { render, staticRenderFns } from "./ofd_mr.vue?vue&type=template&id=082b4d14&"
import script from "./ofd_mr.vue?vue&type=script&lang=js&"
export * from "./ofd_mr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports